import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { shallowMemoize } from '@sail/utils';
import ListPattern from 'cldr-listpattern';
import createGlobalizeWithLocale from '../../internal/createGlobalizeWithLocale/createGlobalizeWithLocale';
import handleGlobalizeError from '../../internal/errors/handleGlobalizeError/handleGlobalizeError';
import mergeOptions from '../../internal/mergeOptions';
const intlTypeToCldrPatternType = {
    conjunction: 'standard',
    disjunction: 'or',
    unit: 'unit'
};
const splitRegExp = /%%%/g;
const getFormatter = shallowMemoize((config, locale, reports)=>{
    try {
        const globalize = createGlobalizeWithLocale(config, locale, undefined, reports);
        const listPatternData = globalize.cldr.main('listPatterns');
        return new ListPattern(listPatternData);
    } catch (error) {
        handleGlobalizeError(error, reports);
    }
});
const getPatternType = (options)=>{
    const cldrType = intlTypeToCldrPatternType[options.type];
    const patternType = [
        cldrType
    ];
    if (options.style !== 'long') {
        patternType.push(options.style);
    }
    return patternType.filter(Boolean).join('-');
};
const format = (items, options, config, reports)=>{
    const formatter = getFormatter(config, options.locale, reports);
    return formatter(items, {
        patternType: getPatternType(options)
    });
};
function isFormatListItemText(item) {
    return typeof item === 'string' || typeof item === 'number';
}
/**
 * @see https://sail.stripe.me/apis/intl/useIntl/#format-list
 */ function formatList(/** The intl config object containing the locale data. When using this API through the `useIntl` hook, this config object is automatically injected. */ config, reports, items, options) {
    const defaults = {
        type: 'conjunction',
        style: 'long',
        locale: config.locale
    };
    const mergedOptions = mergeOptions(config, defaults, reports, options);
    if (items.every(isFormatListItemText)) {
        return format(items, mergedOptions, config, reports);
    }
    const ids = items.map((_, idx)=>`%%%${idx}%%%`);
    const formattedIdList = format(ids, mergedOptions, config, reports);
    const splitList = `${formattedIdList}`.split(splitRegExp);
    const chunks = splitList.reduce((acc, listPart, index)=>{
        /* eslint-disable react/no-array-index-key */ // The ID placeholders are always odd indexes
        if (index % 2 === 1) {
            acc.push(/*#__PURE__*/ _jsx("span", {
                children: items[parseInt(listPart, 10)]
            }, index));
        } else if (listPart !== '') {
            acc.push(/*#__PURE__*/ _jsx("span", {
                children: listPart
            }, index));
        }
        /* eslint-enable react/no-array-index-key */ return acc;
    }, []);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: chunks
    });
}
export default formatList;

//# sourceMappingURL=formatList.js.map